const Quote = ({ quote }) => {
  return <q>{quote}</q>;
};

export default Quote;
